import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { ShipmentProfileReport } from '../models';
import { ShipmentPlannerProfileEndpoint } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class ShipmentPlannerProfileReportService {
  constructor(private http: WrapperHttpService) {}

  getReport(): Observable<ShipmentProfileReport> {
    const url = `${API_URL}${ShipmentPlannerProfileEndpoint.Base}${ShipmentPlannerProfileEndpoint.Profiles}${ShipmentPlannerProfileEndpoint.Report}${ShipmentPlannerProfileEndpoint.Fields}`;
    return this.http.withLoading().get<ShipmentProfileReport>(url);
  }
}
